module.exports = __webpack_public_path__ + "aa72de2fe690b72053538470babdca83.svg";